import { FC } from 'react';

import { ClearanceStatus } from '@/types';

interface StatusBadgeProps {
  status: ClearanceStatus;
}

export const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
  const getBadgeStyles = (status: ClearanceStatus) => {
    switch (status) {
      case 'Approved':
        return 'bg-green-500/20 text-green-400 border-green-500/30';
      case 'Rejected':
        return 'bg-red-500/20 text-red-400 border-red-500/30';
      case 'Revoked':
        return 'bg-red-600/20 text-red-500 border-red-600/30';
      case 'Canceled':
        return 'bg-orange-500/20 text-orange-400 border-orange-500/30';
      case 'Pending':
        return 'bg-yellow-500/20 text-yellow-500 border-yellow-500/30';
      case 'Revoking':
        return 'bg-red-400/20 text-red-300 border-red-400/30';
      case 'Canceling':
        return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
      default:
        return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
    }
  };

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${getBadgeStyles(status)}`}
    >
      {status}
    </span>
  );
};
